/**
 * TanStack Query hooks for body composition and immunscan measurements.
 */

import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../client'
import type {
  BodyCompositionOut,
  ImmunscanOut,
} from '../types'

// ── Body Composition ────────────────────────────────────────────────

/** All body composition (mescan) measurements. */
export function useBodyComposition() {
  return useQuery({
    queryKey: ['body'],
    queryFn: () => apiFetch<BodyCompositionOut[]>('/api/body'),
  })
}

/** All immunscan measurements. */
export function useImmunscan() {
  return useQuery({
    queryKey: ['immunscan'],
    queryFn: () => apiFetch<ImmunscanOut[]>('/api/immunscan'),
  })
}
